"use client";
import * as React from "react";
const SvgCallRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m14.43 10.91-2.26-.26a1.8 1.8 0 0 0-1.46.51L9.07 12.8A13.4 13.4 0 0 1 3.2 6.93l1.65-1.65c.38-.38.57-.92.5-1.46L5.1 1.58A1.8 1.8 0 0 0 3.33 0H1.78C.78 0-.06.84 0 1.84A15.14 15.14 0 0 0 14.16 16c1 .06 1.84-.78 1.84-1.78v-1.55a1.8 1.8 0 0 0-1.57-1.76" }));
export {
  SvgCallRound as default
};
